// Section1.js
import React from 'react';
import { TbDevices } from "react-icons/tb";

import Button from './Button.js';
const SectionPrice = ({ instalment, price, number, link }) => {
    return (
        <div className="section-container color">
            <div className="text-column-u">
                <div className='white section-container line'><span className='white icon'><TbDevices /></span>Aproveite o conteúdo em qualquer dispositivo</div>
                <h4 className='white'>Por apenas</h4>
                <p className='white price' style={{ 'marginTop': '-20px' }}>{number} x <span style={{ 'fontSize': '18px' }}>R$ </span>{instalment}</p>
                <p className='white' style={{ 'marginTop': '-20px' }}>ou R$ {price} a vista</p>
                <Button href={link} />
                <p className='white'>PAGAMENTO 100% SEGURO COM ACESSO IMEDIATO</p>

            </div>
        </div>
    );
};

export default SectionPrice;
